// Per-purpose concurrency caps — wired from C2 budget.ts (Q2).
import { PROMPT_CONCURRENCY_CAPS } from '../prompts/budget.js';
import type { PromptPurpose } from '../prompts/types.js';

class Semaphore {
  private running = 0;
  private queue: Array<() => void> = [];
  constructor(private max: number) {}
  async run<T>(fn: () => Promise<T>): Promise<T> {
    if (this.running >= this.max) {
      await new Promise<void>((res) => this.queue.push(res));
    }
    this.running++;
    try {
      return await fn();
    } finally {
      this.running--;
      this.queue.shift()?.();
    }
  }
}

const queues = new Map<PromptPurpose, Semaphore>();

export function purposeQueue(purpose: PromptPurpose): Semaphore {
  let q = queues.get(purpose);
  const cap = PROMPT_CONCURRENCY_CAPS[purpose] ?? 1;
  if (!q) {
    q = new Semaphore(cap);
    queues.set(purpose, q);
  }
  return q;
}

/** Reset queue singletons between tests. */
export function resetPurposeQueues(): void {
  queues.clear();
}
